import React from 'react'
import ParkingZone from './parking-zone'
import style from './index.module.scss'

export const parkingZones = ({ carParks, centre, noBorder }) =>
  (Array.isArray(carParks) ? carParks : [])
    .slice()
    .map(carPark => (
      <ParkingZone
        className={noBorder ? '' : style.parkingZoneBorder}
        key={carPark.sys.id}
        carParkName={carPark.title}
        carParkLocation={carPark.location}
        carParkEntrance={carPark.entrance}
        bestParkingFor={
          carPark.bestParkingForCollection
            ? carPark.bestParkingForCollection.items
            : carPark.bestParkingFor
        }
        latitude={carPark.latitude}
        longitude={carPark.longitude}
        centreSlug={centre.slug}
      />
    ))
